import CookieBox from "cookie-consent-box";

new CookieBox().init();
